export const toAssociatedResourceAnnotation = function ({
  id,
  commentReference: reference,
  commentTarget, commentCategory: category,
  body,
  privacy,
  owner,
  active,
  aol
}) {
  const target = `urn:esv:article:${aol}:${commentTarget}`
  const uri = `urn:esv:associated-resource:${id}`
  const content = JSON.stringify({
    reference,
    body,
    active,
    category
  })

  return {
    uri,
    party: {
      type: 'PartyRef',
      uri: owner
    },
    content: {
      content,
      uri,
      target,
      isPrivate: privacy === 'private'
    }
  }
}
